import React from 'react'
import classNames from "classnames";
import PropTypes from "prop-types";

import {Texts, Helpers} from '@eyecons/storybook'
import {Status} from "./Status";

const containers = {
    link: ({className, video, children, to}) => (
        <a
            href={to || `/${video.url_video || video.url}`}
            className={className}
            target={'_blank'}
        >
            {children}
        </a>
    ),
    button: ({className, children, onClick}) => (
        <button
            onClick={onClick}
            className={className}
        >
            {children}
        </button>
    ),
};

export function Card({className, video, onClick, to, variant = 'responsive'}) {
    const Container = containers[onClick ? "button" : "link"];


    return (
        <Container
            video={video}
            className={classNames(
                'cursor-pointer gap-2 grid grid-cols-1',
                {
                    'grid-cols-1': variant === 'responsive'
                },
                className
            )}
            onClick={() => onClick(video)}
            to={to}
        >
            <div className={classNames('max-sm:col-span-3', {
                'col-span-4': variant === 'fixed',
                'col-span-1': variant === 'responsive'
            })}>
                <div style={{aspectRatio: '16 / 9', width: '100%', backgroundImage: `url(${video.thumbnail})`}}
                     className={'relative rounded-lg bg-cover bg-center'}>
                    <div
                        className={'inset-x-0 bottom-0 top-1/2 absolute bg-gradient-to-b from-transparent to-black rounded-lg'}>
                        {variant !== 'fixed' && video.is_premium && (
                            <Status
                                className={'bottom-3 right-3 absolute hidden sm:block'}
                                type={'secondary'}
                            >
                                Premium
                            </Status>
                        )}
                        {video.length?.seconds > 0 && !video.is_premium && (
                            <span
                                className={'absolute right-2 bottom-2 rounded-md text-white text-xs uppercase text-center bg-black bg-opacity-70 px-2 py-1'}
                            >
                            {video.length.seconds.time()}
                        </span>
                        )}
                    </div>
                </div>
            </div>

            <div className={classNames('overflow-hidden flex flex-col gap-1 text-white text-left', {
                'max-xs:col-span-6 max-sm:col-span-7': video.is_premium,
                'max-sm:col-span-9': !video.is_premium,
                'col-span-6': variant === 'fixed' && video.is_premium,
                'col-span-8': variant === 'fixed' && !video.is_premium,
                'col-span-1': variant === 'responsive'
            })}>
                <p className={classNames("storybook-videos-card-title", className)}>{video.title}</p>
                <div className={'flex flex-col'}>
                    <span className={'text-xs font-light'}>
                        {
                            Boolean(video.views) &&
                            <span>{Helpers.fixedNumbers(video.views)}{" "}{video.views === 1 ? "weergave" : "weergaven"}{" • "}</span>}
                        {video.created_at && Helpers.uploadTime(video.created_at.raw)}
                    </span>
                </div>
            </div>

            {
                video.is_premium && <div className={'max-xs:col-span-3 col-span-2 sm:hidden'}>
                    <Status
                        size={'small'}
                        type={'secondary'}
                    >
                        Premium
                    </Status>
                </div>
            }
        </Container>
    );
}

Card.propTypes = {
    /**
     * Use a different classname mostly for color binding
     */
    className: PropTypes.string,

    video: PropTypes.shape({
        /**
         * The title of the Video
         */
        title: PropTypes.string.isRequired,

        /**
         * The title of the Video
         */
        slug: PropTypes.string.isRequired,

        /**
         * Type of sport or theme of the video
         */
        type: PropTypes.string,

        /**
         * url of the video thumbnail
         */
        thumbnail: PropTypes.string,

        /**
         * Length of the video being placed
         */
        time: PropTypes.string,
    }).isRequired,
};
